<div class="container-fluid p-4">
	@if (companyGroup !== undefined) {
		<app-report-generator [selectedReport]="enums.CHARGES_BALANCE_SUMMARY" [selectedCompanyGroup]="companyGroup" [selectedCompany]="companyId"></app-report-generator>
	}
	<div class="p-2 mt-2">
		<h2>Charges Balance Summary</h2>
		<div class="d-flex gap-3">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Search</mat-label>
				<input matInput type="text" placeholder="Search" [(ngModel)]="searchText" (keyup)="applyFilter($event)" />
			</mat-form-field>

			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Capital%</mat-label>
				<input matInput type="number" placeholder="%" min="0" [(ngModel)]="capitalPercentage" (keypress)="sharedService.isNumberKey($event)" />
			</mat-form-field>
			<mat-form-field subscriptSizing="dynamic" class="w-100">
				<mat-label>Transaction Type</mat-label>
				<mat-select multiple panelClass="min-width-max-content" [(ngModel)]="selectedTransType" (selectionChange)="toggleColumns()">
					@for (t of transType; track t.id) {
						<mat-option [value]="t.columnName">{{ t.text }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
	</div>
	<table mat-table [dataSource]="dataSource" matSort>
		<ng-container matColumnDef="CompanyCode">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Company Code</th>
			<td mat-cell *matCellDef="let finance">{{ finance.CompanyCode }}</td>
		</ng-container>
		<ng-container matColumnDef="CapitalBalance">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="align-end">Capital Balance</th>
			<td mat-cell *matCellDef="let finance">{{ finance.CapitalBalance | number: '1.2-2' }}</td>
		</ng-container>

		<ng-container matColumnDef="CapitalInterest">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="align-end">Capital SC ({{ capitalPercentage ?? 100 }}%)</th>
			<td mat-cell *matCellDef="let finance">{{ (finance.CapitalBalance * (capitalPercentage ?? 100)) / 100 | number: '1.2-2' }}</td>
		</ng-container>

		<ng-container matColumnDef="StampBalance">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="align-end">Stamp Office Balance</th>
			<td mat-cell *matCellDef="let finance">{{ finance.StampBalance | number: '1.2-2' }}</td>
		</ng-container>
		<ng-container matColumnDef="ScBalance">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="align-end">SC Balance</th>
			<td mat-cell *matCellDef="let finance">{{ finance.ScBalance | number: '1.2-2' }}</td>
		</ng-container>
		<ng-container matColumnDef="ExtrasBalance">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="align-end">DL Balance</th>
			<td mat-cell *matCellDef="let finance">{{ finance.ExtrasBalance | number: '1.2-2' }}</td>
		</ng-container>
		<ng-container matColumnDef="HandlingChargeBalance">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="align-end">Handling Charge Balance</th>
			<td mat-cell *matCellDef="let finance">{{ finance.HandlingChargeBalance | number: '1.2-2' }}</td>
		</ng-container>
		<ng-container matColumnDef="UnpaidComm">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="align-end">Unpaid Commission</th>
			<td mat-cell *matCellDef="let finance">{{ finance.UnpaidComm | number: '1.2-2' }}</td>
		</ng-container>
		<ng-container matColumnDef="LatestCheckin">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Last Checked In</th>
			<td mat-cell *matCellDef="let finance">{{ finance.LatestCheckin | date: 'dd/MM/yyyy' }}</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
	<mat-paginator [pageSize]="50" [pageSizeOptions]="[50, 100, 200, 500]" showFirstLastButtons> </mat-paginator>
</div>
